/**
 * ÖDEME YÖNTEMİ ETİKETLERİ.
 *
 * Shopify ham teknik değer döndürüyor (`card`, `bank_transfer`, `manual`).
 * Ekranda bunları göstermek kullanıcıya hiçbir şey anlatmıyor; üstelik
 * havale ile kart ayrımı bu işletme için KRİTİK: kart ödemesi anında onaylı,
 * havale ise para hesaba geçene kadar üretime düşmüyor.
 */

export type PaymentTone = "card" | "transfer" | "cash" | "other";

interface PaymentLabel {
  label: string;
  tone: PaymentTone;
  /** Ödemenin peşin onaylı sayılıp sayılmadığı — üretim kararında anlamlı. */
  instant: boolean;
}

const MAP: Record<string, PaymentLabel> = {
  card: { label: "Kredi Kartı", tone: "card", instant: true },
  shopify_payments: { label: "Kredi Kartı", tone: "card", instant: true },
  iyzico: { label: "iyzico (Kart)", tone: "card", instant: true },
  "iyzico checkout": { label: "iyzico (Kart)", tone: "card", instant: true },
  online: { label: "Online Ödeme", tone: "card", instant: true },
  "online ödeme": { label: "Online Ödeme", tone: "card", instant: true },

  bank_transfer: { label: "Havale / EFT", tone: "transfer", instant: false },
  banktransfer: { label: "Havale / EFT", tone: "transfer", instant: false },
  havale: { label: "Havale / EFT", tone: "transfer", instant: false },
  "havale/eft": { label: "Havale / EFT", tone: "transfer", instant: false },
  bacs: { label: "Havale / EFT", tone: "transfer", instant: false },

  cod: { label: "Kapıda Ödeme", tone: "cash", instant: false },
  cash_on_delivery: { label: "Kapıda Ödeme", tone: "cash", instant: false },
  "kapıda ödeme": { label: "Kapıda Ödeme", tone: "cash", instant: false },

  manual: { label: "Elle Kaydedilen", tone: "other", instant: false },
  gift_card: { label: "Hediye Kartı", tone: "other", instant: true },
};

export function paymentLabel(raw: string | null | undefined): PaymentLabel {
  const key = String(raw ?? "").trim().toLocaleLowerCase("tr");
  if (!key) return { label: "—", tone: "other", instant: false };
  return MAP[key] ?? { label: raw as string, tone: "other", instant: false };
}

export const PAYMENT_TONE_CLASS: Record<PaymentTone, string> = {
  card: "bg-emerald-50 text-emerald-800 ring-emerald-200",
  transfer: "bg-amber-50 text-amber-900 ring-amber-200",
  cash: "bg-sky-50 text-sky-800 ring-sky-200",
  other: "bg-gray-100 text-gray-700 ring-gray-200",
};

/** Shopify `financial_status` → Türkçe. */
export function financialLabel(raw: string | null | undefined): string {
  const k = String(raw ?? "").trim().toLowerCase();
  const m: Record<string, string> = {
    paid: "Ödendi",
    pending: "Ödeme Bekliyor",
    partially_paid: "Kısmi Ödendi",
    refunded: "İade Edildi",
    partially_refunded: "Kısmi İade",
    voided: "İptal",
    authorized: "Provizyon",
    expired: "Süresi Doldu",
  };
  return m[k] ?? (raw ? String(raw) : "—");
}
